module.exports = __webpack_public_path__ + "static/use-case-8-content-1-19b6a9dced9612bfbfcbd58ed9e360f9.png";